import dayjs from 'dayjs'

const PENDING_TEXT = '待补充'

const formatDate = (date) => {
  if (!date) return ''
  const parsed = dayjs(date)
  return parsed.isValid() ? parsed.format('YYYY/MM/DD') : ''
}

const getStatusType = (status) => {
  if (['报价中', '待确认', '处理中'].includes(status)) return 'processing'
  if (['已确认', '成行', '已完成', '已走团'].includes(status)) return 'success'
  if (['已取消', '丢失'].includes(status)) return 'error'
  return 'default'
}

const isEmpty = (value) => value === null || value === undefined || value === ''

const buildDateRange = (order) => {
  const startDate = formatDate(order.start_date)
  if (!startDate) return ''
  if (isEmpty(order.days)) return startDate
  const end = dayjs(order.start_date).add(order.days - 1, 'day')
  return end.isValid() ? `${startDate} - ${end.format('MM/DD')}` : startDate
}

const buildPeopleText = (order) => {
  const parts = []
  if (!isEmpty(order.aldult_number)) parts.push(`成人${order.aldult_number}`)
  if (!isEmpty(order.child_number)) parts.push(`儿童${order.child_number}`)
  if (!isEmpty(order.baby_number)) parts.push(`婴儿${order.baby_number}`)
  return parts.join(' · ')
}

export const mapRelatedOrders = (orders = []) => orders.map((order, index) => {
  const status = order.order_status || ''
  const orderSn = order.order_sn ?? null

  return {
    key: orderSn ?? order.id ?? index,
    orderSn,
    orderNo: order.order_id || `订单号${PENDING_TEXT}`,
    quotationName: order.quotation_name || '',
    status,
    statusType: getStatusType(status),
    dateRange: buildDateRange(order),
    peopleText: buildPeopleText(order),
    daysText: isEmpty(order.days) ? '' : `${order.days}天`,
    orderMl: order.order_ml,
  }
})
